/**
 * Common functionality for the DigitalEvent common components
 */

export default {
  directives: {
    focus: {
      inserted: el => {
        el.focus();
      }
    }
  },
  computed: {
    /**
     * Get global access to the Theme styles
     * @return {(function(): default.computed.$store.state.themeStyles)|Object|{}}
     */
    themeStyles() {
      return this.$store.state.themeStyles;
    },

    /**
     * Global loading flag (for UI components)
     * @return {boolean}
     */
    isLoading() {
      return !!this.$store.state.requestCounter;
    },

    /**
     * Global Full-page preloader flag
     * @return {boolean}
     */
    useFullPagePreloader() {
      return this.isLoading && this.$store.state.useFullPagePreloader;
    },

    /**
     * Current authorize user from redis session
     * @return {Object}
     */
    user() {
      return this.$store.state.users.user;
    },

    /**
     * Current user's full name
     * @return {string}
     */
    userFullName() {
      let user = this.$store.getters["users/getUser"](this.user.user_uuid);
      return user ? this.$store.getters["users/getUserFullName"](user) : "";
    },

    /**
     * Event info
     * @return {Object}
     */
    event() {
      return this.$store.state.event.context;
    },

    /**
     * Banner's headers
     * @return {Object}
     */
    systemHeaders() {
      return this.$store.getters["config/systemHeaders"];
    },

    /**
     * Banner's messages
     * @return {Object}
     */
    systemMessages() {
      return this.$store.getters["config/systemMessages"];
    }
  }
};
